// extracted by mini-css-extract-plugin
module.exports = {"etfHero":"ETFHero-module--etfHero--j3Jqi"};